import React from "react";
import { Popover } from "react-bootstrap";
import { PopoverStyled } from "../aside.style";

export const popover = (header: any, body: any) => (
  <PopoverStyled id="popover-basic">
    <Popover.Header className="poppoverHeader" as="p">
      {header}
    </Popover.Header>
    <Popover.Body style={{ padding: "2px 12px" }}>{body}</Popover.Body>
  </PopoverStyled>
);
